<template>
    <div class="photo-upload-area">
        <!-- Loaded photos list -->
        <transition name="fade-transition">
            <v-card flat outlined class="photo-upload-list mb-5" v-if="photos.length">
                <v-container fluid class="primary">
                    <v-slide-y-transition group tag="div" class="row row--dense">
                        <v-col cols=6 sm=4 v-for="(photo) in photos" :key="photo.id">
                            <!-- Photo list item card -->
                            <div class="photo-uploader-list-item">
                                <v-checkbox v-model="activePhotos" :id="'checkbox-'+ photo.id" :value="photo.id" class="check-box-hidden"></v-checkbox>
                                <label :for="'checkbox-'+ photo.id">
                                    <card-media-upload :photo="photo" @deletePhoto="deletePhoto" @openDialog="openDialog" editOptions></card-media-upload>
                                </label>
                            </div>
                        </v-col>
                    </v-slide-y-transition>
                </v-container>
            </v-card>
        </transition>
        <!-- File upload placeholder -->
        <v-card flat ripple class=" grey--border" v-if="photos.length < photoLimit"  height=200 outlined @click="onPickFile">
            <!-- input file displayed none taken as ref on card click -->
            <input type="file" name="" style="display: none" ref="fileInput" accept="image/*" multiple @change="onFilePicked">
            <v-container fill-height justify-center>
                <div class="text-center">
                    <v-icon size=50 color="grey lighten-1">mdi-camera-plus-outline</v-icon>
                    <span class="d-block grey--text title d-block font-weight-light">
                        Add Photos
                    </span>
                </div>
            </v-container>
            <svg class="placeholder__svg" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                <rect fill="none" :stroke="$vuetify.theme.themes.light.secondaryDarker" x="0" y="0" width="100%" height="100%" stroke-dasharray=10 ref="placeholderRect" />
            </svg>
        </v-card>
        <!--photo edit and dialog -->
        <v-dialog v-model="dialog" v-if="currentPhoto" max-width="600px" @input="!dialog ? currentPhoto = null : ''" persistent>
            <v-card min-height="200">
                <v-container fluid>
                    <v-row>
                        <v-col cols=12>
                            <h3 class="title grey--text font-weight-light text-center"> Edit Photo</h3>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-divider></v-divider>
                    </v-row>
                    <v-row>
                        <v-col cols=12>
                            <v-text-field ref="postTitle" label="Photo Title" color="grey" v-model="currentPhoto.title" outlined background-color=" primary" hide-details tile></v-text-field>
                        </v-col>
                        <v-col cols=12>
                            <v-textarea label="Photo description" color="grey" v-model="currentPhoto.description" outlined background-color="primary" tile></v-textarea>
                        </v-col>
                    </v-row>
                </v-container>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="blue darken-1" text @click="updatePhoto">Save</v-btn>
                    <v-btn color="blue darken-1" text @click="dialog = false">Close</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>
<style scoped>
.placeholder__svg {
    position: absolute;
    left: 50%;
    top: 50%;
    width: 96%;
    height: 74%;
    transform: translateX(-50%) translateY(-50%);
}

.check-box-hidden {
    height: 0;
    overflow: hidden;
    position: absolute;
    visibility: hidden;
}
</style>
<script>
import {
    CLEAR_FILES,
} from "@/store/mutations.type"

import cardMedia from "@/components/cards/card-media-upload.vue"
export default {
    props: ['photos'],
    components: {
        'card-media-upload': cardMedia
    },
    data() {
        return {
            photo: null,
            activePhotos: [],
            currentPhoto: null,
            dialog: false
        }
    },
    computed: {
        photoLimit() {
            return 30
        },

        fileLoading() {
            return false
        }
    },
    methods: {
        onPickFile() {
            this.$refs.fileInput.click()
        },

        onFilePicked(event) {
            if (event.target.files.length) {
                //this.$store.dispatch('setFileLoading', true)
                const files = event.target.files
                this.$emit('filesAdded', files)
            }
        },

        deletePhoto(id) {
            this.removeFromActivePhotos(id)
            this.$emit('deletePhoto', id)
        },

        // Active photos helpers
        removeFromActivePhotos(id) {
            if (this.activePhotos.includes(id)) {
                this.activePhotos.splice(this.activePhotos.indexOf(id), 1)
            }
        },

        // Dialogs
        openDialog(photo) {
            this.currentPhoto = Object.assign({}, photo)
            this.dialog = true
        },

        clearAllPhotos() {
            this.$store.commit(CLEAR_FILES, "postUploads")
        },

        updatePhoto() {
            this.$emit('updatePhoto', {
                id: this.currentPhoto.id,
                values: this.currentPhoto
            })
            this.dialog = false
        }


    }

}
</script>